module.exports = __webpack_public_path__ + "static/media/ames-ust.5d6a8bcb.svg";